import React from 'react';
import PropTypes from 'prop-types';

const DraggedGridRowPreview = ({ selectedPreviewItems }) => {
  const renderGridRowsPreview = () =>
    selectedPreviewItems.map(item => (
      <div key={item.id}>
        <span className="large-8 columns dragged-preview-item">
          {item.title}
        </span>
        <span className="large-2 columns dragged-preview-item">
          {item.sample}
        </span>
        <span className="large-2 columns dragged-preview-item">
          {item.weighted}
        </span>
      </div>
    ));

  return (
    <div className="row">
      <div className="large-6 columns dragged-preview-grid">
        {renderGridRowsPreview()}
      </div>
    </div>
  );
};

DraggedGridRowPreview.propTypes = {
  selectedPreviewItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DraggedGridRowPreview;
